import { useMemo } from 'react';

import { useFetchContentPerformancesQuery } from '@/modules/corporate/graphql/queries/generated/contentPerformance';
import { CoursePerformanceFragment } from '@/modules/corporate/modules/course/graphql/fragments/generated/CoursePerformance';
import { CoursePerformanceType } from '@/types/schema';

const useJourneyContentPerformances = (
  entityId: string,
  userIds: string[],
  includeLockSettings = true,
) => {
  const [{ fetching, data, error }] = useFetchContentPerformancesQuery({
    variables: {
      filters: { entityIds: [entityId], userIds },
      first: userIds.length,
      includeLockSettings,
    },
    pause: !userIds.length,
    requestPolicy: 'cache-and-network',
  });

  const contentPerformance = useMemo(
    () =>
      data?.contentPerformances.edges?.reduce(
        (acc, edge) => {
          const node = edge.node as (typeof acc)['0'];
          if (!node?.userId) {
            return acc;
          }

          acc[node.userId] = node;
          return acc;
        },
        {} as Record<
          string,
          CoursePerformanceFragment & { lockSettings?: CoursePerformanceType['lockSettings'] }
        >,
      ),
    [data?.contentPerformances.edges],
  );

  return { fetching, error, data: contentPerformance };
};

export default useJourneyContentPerformances;
